var _path, _path2, _path3, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconeClientes(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.20852 25.6665H18.124C18.8767 25.6665 19.469 25.0421 19.319 24.3045C18.905 22.2681 17.5526 18.6665 13.1663 18.6665C8.78003 18.6665 7.42768 22.2681 7.0136 24.3045C6.86362 25.0421 7.45586 25.6665 8.20852 25.6665Z",
    stroke: "#3F3F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18.6665C24.2717 18.6665 25.4069 21.5304 25.8652 23.5945C26.1127 24.7092 25.2111 25.6665 24.0692 25.6665H22.8333",
    stroke: "#3F3F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1667 13.6668C15.1917 13.6668 16.8333 12.0252 16.8333 10.0002C16.8333 7.97512 15.1917 6.3335 13.1667 6.3335C11.1416 6.3335 9.5 7.97512 9.5 10.0002C9.5 12.0252 11.1416 13.6668 13.1667 13.6668Z",
    stroke: "#3F3F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M20.167 13.6668C22.1921 13.6668 23.5003 12.0252 23.5003 10.0002C23.5003 7.97512 22.1921 6.3335 20.167 6.3335",
    stroke: "#3F3F55",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconeClientes);
export default __webpack_public_path__ + "static/media/icone-clientes.d761c9a0a643105d414ba9b349a2b05e.svg";
export { ForwardRef as ReactComponent };